import { inject, Injectable } from '@angular/core';
import { WindowModel } from 'src/app/models/authentication/window.model';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WindowProfileUserModel } from 'src/app/models/authentication/window-profile-user.model';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';

@Injectable({
  providedIn: 'root'
})
export class WindowService {

  private readonly _httpClient = inject(HttpClient);

  getAllWindow(): Observable<Array<WindowModel>> {
    return this._httpClient.get<Array<WindowModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.window.GetAllWindow}`)
  }

  createWindow(windowModel: WindowModel) {
    return this._httpClient.post<WindowModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.window.CreateWindow}`,
      windowModel
    );
  }

  getWindowsByCompany(companyId: number): Observable<Array<WindowModel>> {
    return this._httpClient.get<Array<WindowModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.window.GetWindowsByCompany}/${companyId}`);
  }

  getWindowsByCompanyAuthenticated(): Observable<Array<WindowModel>> {
    return this._httpClient.get<Array<WindowModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.window.GetWindowsByCompanyAuthenticated}`);
  }

  getWindowsByProfileUser(profileUserId: number): Observable<Array<WindowProfileUserModel>> {
    return this._httpClient.get<Array<WindowProfileUserModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.window.GetWindowsByProfileUser}/${profileUserId}`);
  }

  getWindowsByUserAuthenticated(): Observable<Array<WindowProfileUserModel>> {
    return this._httpClient.get<Array<WindowProfileUserModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.window.GetWindowsByUserAuthenticated}`);
  }

  saveWindowsByCompany(companyId: number, windowsIds: Array<number>): Observable<Array<number>> {
    return this._httpClient.post<Array<number>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.window.SaveWindowsByCompany}/${companyId}`,
      windowsIds)
  }

  saveWindowsByProfileUser(profileUserId: number, windowsIds: Array<WindowProfileUserModel>): Observable<Array<WindowProfileUserModel>> {
    return this._httpClient.post<Array<WindowProfileUserModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.window.SaveWindowsByProfileUser}/${profileUserId}`,
      windowsIds)
  }

  getPermissionProfileByUrl(url: string): Observable<boolean> {
    const itemFilterResponse = new ItemFilterModel("url", null, null, url);
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.window.GetPermissionProfileUserByUrl}`, itemFilterResponse);
  }
}